import { createFileRoute } from "@tanstack/react-router";
import { faqPageScript, i18nLinks, i18nOgMeta } from "@/lib/seo";
import { m } from "@/paraglide/messages";
import {
  racesQueryOptions,
  seasonsQueryOptions,
} from "@/tools/f1-fantasy/hooks/use-f1-data";
import { DEFAULT_SEASON } from "@/tools/f1-fantasy/lib/constants";
import { F1FantasyHome } from "@/tools/f1-fantasy/pages/F1FantasyHome";

export const Route = createFileRoute("/f1-fantasy/")({
  ssr: true,
  loader: async ({ context }) => {
    const seasons = await context.queryClient.ensureQueryData(
      seasonsQueryOptions(),
    );
    const latestSeason = seasons?.[0]?.year ?? DEFAULT_SEASON;
    // Ensure races are loaded before rendering — avoids SSR/client hydration mismatch
    // (prefetchQuery would dehydrate the data to the client, making it render actual
    // content during hydration while the server DOM has a loading skeleton → mismatch)
    await context.queryClient.ensureQueryData(racesQueryOptions(latestSeason));
    return { season: latestSeason };
  },
  head: () => ({
    meta: [
      { title: "F1 Fantasy | Toolverse" },
      {
        name: "description",
        content:
          "Your all-in-one F1 Fantasy hub. Apex Team optimizer, Budget Boost price predictions, standings, fantasy points, and driver & constructor statistics.",
      },
      { property: "og:title", content: "F1 Fantasy | Toolverse" },
      {
        property: "og:description",
        content:
          "AI-powered F1 Fantasy tools: Apex Team optimizer, Budget Boost price predictions, standings, and race statistics.",
      },
      ...i18nOgMeta("/f1-fantasy"),
    ],
    links: [...i18nLinks("/f1-fantasy")],
    scripts: [
      faqPageScript([
        { q: m.f1_faq1_q(), a: m.f1_faq1_a() },
        { q: m.f1_faq2_q(), a: m.f1_faq2_a() },
        { q: m.f1_faq3_q(), a: m.f1_faq3_a() },
        { q: m.f1_faq4_q(), a: m.f1_faq4_a() },
        { q: m.f1_faq5_q(), a: m.f1_faq5_a() },
      ]),
    ],
  }),
  component: F1FantasyHome,
});
